import React, { useState, useEffect } from 'react';
import './App.css';
import { withTranslation } from 'react-i18next';
import axios from 'axios';
import InstallerApp from './InstallerApp';
import WithLoading from './components/WithLoading/WithLoading';
import EndUserApp from './EndUserApp';
import ShowError from './components/ShowError/ShowError';

const ShowAppWithLoading = WithLoading(AppComponent);

function App({t}) {
  const [endUserAppConfig, setEndUserAppConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_URL + `/qr/info/customer/STI%23` + encodeURIComponent(id) + '?time=' + Date.now(), {timeout: 30000});
        setEndUserAppConfig(response.data);
      } catch (error) {
        console.error('Error fetching customer:', error);
        setErrorMessage(t("error.loading"));
      } finally {
        setLoading(false);
      }
    };

    fetchCustomer();
  }, [id, t]);

  if (loading) {
    return (
      <div className="centered-spinner">
        <ShowAppWithLoading isLoading={loading} />
      </div>
    );
  }

  if (errorMessage) {
    return (
      <div className="App">
        <img src={process.env.PUBLIC_URL + "/assets/images/thermovault-logo-white.svg"} className="App-logo" alt="logo" />
        <ShowError error_msg={errorMessage} />
      </div>
    );
  }

  return (
    <ShowAppWithLoading isLoading={loading} endUserAppConfig={endUserAppConfig} />
  );
}

function AppComponent({endUserAppConfig}) {
  if (endUserAppConfig.holidayModeEnabled || endUserAppConfig.operationModeEnabled || endUserAppConfig.reportingEnabled) {
    return <EndUserApp endUserAppConfig={endUserAppConfig} />;
  }
  return (
    <div className="App">
      <img src={process.env.PUBLIC_URL + "/assets/images/thermovault-logo-white.svg"} className="App-logo" alt="logo" />
      <InstallerApp />
    </div>
  );
}

export default withTranslation()(App);
